import { IRespRateRepository } from "../../adapters/driven/repositories/respRateRepository";

export const RespRateServiceImplFactory = ({
  respRateRepository,
}: {
  respRateRepository: IRespRateRepository;
}) => {
  const getRespRate: IGetRespRate = async ({ patientIds, clinicId }) => {
    try {
      const response = await respRateRepository.getRespRateAPI({
        patient_ids: patientIds,
        clinic_id: clinicId,
      });
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };
  return {
    getRespRate,
  };
};
